/* PDP rabbit holes with rotating product photos. Spark records unchanged. */
(function () {
  var root = document.getElementById('gpc-related');
  if (!root) return;
  var C = (window.GPC && window.GPC.classify) || null;
  var title = root.getAttribute('data-title') || '';
  var vendor = root.getAttribute('data-vendor') || '';
  var desc = root.getAttribute('data-body') || '';
  var currentHandle = root.getAttribute('data-handle') || '';
  var forgetEl = root.querySelector('[data-related-forget]');
  var forgetGrid = root.querySelector('[data-related-forget-grid]');
  var typesEl = root.querySelector('[data-related-types]');
  var typesGrid = root.querySelector('[data-related-types-grid]');
  var typesTitle = root.querySelector('[data-related-types-title]');
  var typesBlurb = root.querySelector('[data-related-types-blurb]');
  var homeBtn = root.querySelector('[data-related-home]');
  var previewPools = {};
  var previewIndex = {};
  var previewTimers = [];
  var relatedPools = null;

  var FORGET = [
    { id: 'eyes', label: 'Eye protection', href: '/pages/gear?cat=eyes', q: 'shooting glasses' },
    { id: 'hearing', label: 'Ear protection', href: '/pages/gear?cat=hearing', q: 'ear muff' },
    { id: 'cleaning', label: 'Cleaning', href: '/pages/gear?cat=cleaning', q: 'gun cleaning kit' },
    { id: 'storage', label: 'Range bags', href: '/pages/gear?cat=storage&type=bags', q: 'range bag' },
    { id: 'knives', label: 'Knives', href: '/pages/knives', q: 'knife' },
    { id: 'optics', label: 'Optics', href: '/pages/optics', q: 'red dot' },
    { id: 'defense', label: 'Defense', href: '/pages/gear?cat=defense', q: 'pepper spray' },
    { id: 'batteries', label: 'Batteries', href: '/pages/gear?cat=batteries', q: 'CR123' }
  ];
  var FORGET_EXTRA = [
    { id: 'lights', label: 'Flashlights', href: '/pages/gear?cat=lights', q: 'flashlight' },
    { id: 'slings', label: 'Slings', href: '/pages/gear?cat=slings', q: 'sling' },
    { id: 'med', label: 'First aid', href: '/pages/gear?cat=med', q: 'tourniquet' },
    { id: 'range', label: 'Range gear', href: '/pages/gear?cat=range', q: 'target' }
  ];
  var GENERIC_TYPES = [
    { id: 'magazines', label: 'Magazines', href: '/pages/parts?type=magazines', q: 'magazine' },
    { id: 'holsters', label: 'Holsters', href: '/pages/parts?type=holsters', q: 'holster' },
    { id: 'sights', label: 'Sights', href: '/pages/parts?type=sights', q: 'tritium sight' },
    { id: 'grips', label: 'Grips', href: '/pages/parts?type=grips', q: 'pistol grip' },
    { id: 'stocks', label: 'Stocks', href: '/pages/parts?type=stocks', q: 'stock' },
    { id: 'triggers', label: 'Triggers', href: '/pages/parts?type=triggers', q: 'trigger' },
    { id: 'barrels', label: 'Barrels', href: '/pages/parts?type=barrels', q: 'barrel' },
    { id: 'optics', label: 'Optics', href: '/pages/optics', q: 'red dot' },
    { id: 'lights', label: 'Weapon lights', href: '/pages/optics?type=weapon-lights', q: 'weapon light' },
    { id: 'plates', label: 'Optic plates', href: '/pages/parts?type=plates', q: 'RMR plate' },
    { id: 'mag-extensions', label: 'Mag extensions', href: '/pages/parts?type=mag-extensions', q: 'magazine extension' },
    { id: 'knives', label: 'Knives', href: '/pages/knives', q: 'knife' }
  ];
  var TYPE_Q = {
    magazines: 'magazine',
    'mag-extensions': 'magazine extension',
    holsters: 'holster',
    pouches: 'pouch',
    triggers: 'trigger',
    stocks: 'stock',
    grips: 'grip',
    sights: 'sight',
    plates: 'optic plate',
    barrels: 'BBL',
    lights: 'light',
    slides: 'slide',
    mounts: 'mount',
    compensators: 'muzzle brake',
    'charging-handles': 'charging handle',
    forends: 'forend',
    recoil: 'recoil',
    magwells: 'magwell',
    loaders: 'loader',
    internals: 'hammer',
    tools: 'armorer wrench',
    releases: 'magazine release',
    safeties: 'safety',
    'side-saddles': 'side saddle',
    'sling-mounts': 'sling mount',
    handguards: 'handguard',
    bcg: 'BCG',
    'buffer-tubes': 'buffer tube',
    'gas-tubes': 'gas tube',
    'gas-blocks': 'gas block',
    'end-plates': 'end plate',
    'dust-covers': 'dust cover',
    pins: 'takedown pin',
    springs: 'detent',
    bolts: 'bolt',
    hardware: 'jam nut',
    'rail-covers': 'rail cover'
  };
  var AR15_GAS_SIZE = { Carbine: 1, Mid: 1, Rifle: 1 };

  function esc(s) {
    if (window.GPC && typeof window.GPC.esc === 'function') return window.GPC.esc(s);
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }

  function imgUrl(src) {
    if (window.GPC && typeof window.GPC.img === 'function') return window.GPC.img(src, 400);
    return src || '';
  }

  function hitPrice(hit) {
    if (!hit) return '';
    var raw = hit.price;
    if (raw === undefined || raw === null || raw === '') return '';
    var p = typeof raw === 'string' ? parseFloat(raw) : raw;
    if (isNaN(p)) return '';
    return '$' + p.toFixed(2);
  }

  function blockedMag(u) {
    if (C && C.restrictedOf) {
      return !!C.restrictedOf(u, vendor, '', {});
    }
    if (!/\bRD\b|\bROUND/.test(u)) return false;
    if (/10RD\/\d+|10\/30|10\/\d+RD BDY|BLOCKED|PINNED/.test(u)) return false;
    return /\b(1[1-9]|[2-9]\d)RD\b/.test(u);
  }

  function currentBucket() {
    if (!C) return '';
    if (C.knifeClassify && C.knifeClassify(title, vendor)) return 'knives';
    var g = C.gearClassify && C.gearClassify(title, vendor);
    if (g) return g.cat === 'optics' ? 'optics' : (g.cat || '');
    var p = C.partType ? C.partType(title, vendor, desc) : '';
    return p || '';
  }

  function pickGun() {
    if (!C || !C.gunFamiliesOf || !C.PLATFORMS) return null;
    var ids = C.gunFamiliesOf(title, vendor, desc) || [];
    var i;
    for (i = 0; i < ids.length; i++) {
      var plat = C.PLATFORMS[ids[i]];
      if (plat) return { id: ids[i], plat: plat };
    }
    return null;
  }

  function pickModel(plat, models) {
    if (!models || !models.length) return null;
    var u = String(title || '').toUpperCase();
    var i;
    for (i = 0; i < models.length; i++) {
      var id = String(models[i] || '');
      var token = id.replace(/^G/i, '');
      if (!token) continue;
      var safe = token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      if (new RegExp('\\b' + safe + '\\b', 'i').test(u)) return models[i];
    }
    return models[0];
  }

  function modelLabel(plat, id) {
    if (!id) return '';
    if (plat && plat.modelLabels && plat.modelLabels[id]) return plat.modelLabels[id];
    if (plat && plat.parse === 'glock') return /^G/i.test(id) ? id : 'G' + id;
    return id;
  }

  function queryModel(plat, id) {
    if (!id) return '';
    if (plat && plat.modelLabels && plat.modelLabels[id]) {
      return String(plat.modelLabels[id]).replace(/\s*\/.*$/, '');
    }
    return id;
  }

  function typeLabel(id) {
    if (!id || !C) return id || '';
    var gun = pickGun();
    if (gun && gun.plat.typeLabels && gun.plat.typeLabels[id]) return gun.plat.typeLabels[id];
    var types = C.TYPES || [];
    var i;
    for (i = 0; i < types.length; i++) {
      if (types[i].id === id) return types[i].label;
    }
    return id;
  }

  function typeHref(gunId, model, typeId, plat) {
    if (!gunId || !typeId) return '/pages/parts?type=' + encodeURIComponent(typeId);
    var href = '/pages/' + encodeURIComponent(gunId) + '?type=' + encodeURIComponent(typeId);
    if (model && plat && plat.parse === 'ar15' && (AR15_GAS_SIZE[model] || model === '556')) {
      return href;
    }
    if (model) href += '&model=' + encodeURIComponent(model);
    return href;
  }

  function gunTypeQuery(gun, model, typeId) {
    var name = (gun && gun.plat && gun.plat.name) || (gun && gun.id) || '';
    var word = TYPE_Q[typeId] || String(typeId || '').replace(/-/g, ' ');
    var cal = '';
    if (model === '9mm') cal = '9mm';
    else if (model === '300BLK') cal = '300BLK';
    return [name, cal, word].filter(Boolean).join(' ');
  }

  function picCard(row, hit) {
    var img = hit && hit.image ? imgUrl(hit.image) : '';
    var productHref = hit && hit.handle ? '/products/' + hit.handle : row.href;
    var price = hitPrice(hit);
    var key = esc(row.key);
    var catHref = esc(row.href);
    return '<article class="product-card gpc-related-card gpc-type-preview overflow-hidden" data-preview-key="' + key + '">' +
      '<a href="' + catHref + '" class="gpc-home-mosaic-head"><span class="gpc-mosaic-pill">' + esc(row.label) + '</span></a>' +
      '<a href="' + esc(productHref) + '" class="gpc-related-product" data-related-photo>' +
        '<div class="gpc-related-img">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(hit.title || row.label) + '" width="400" height="400" loading="lazy" decoding="async">' : '') +
        '</div>' +
      '</a>' +
      '<a href="' + catHref + '" class="gpc-related-catlink">' +
        '<div class="gpc-related-title">' + esc((hit && hit.title) || row.label) + '</div>' +
        '<div class="gpc-related-price">' + esc(price) + '</div>' +
      '</a>' +
      '<a href="' + catHref + '" class="gpc-related-more">See more ' + esc(String(row.label || '').toLowerCase()) + '</a>' +
    '</article>';
  }

  function usableHit(hit) {
    if (!hit || !hit.handle || !hit.image) return false;
    if (hit.handle === currentHandle) return false;
    if (hit.inventory_available === false) return false;
    if (C && C.restrictedOf && C.restrictedOf(hit.title, hit.vendor, '', { product_type: hit.product_type })) return false;
    var u = String(hit.title || '').toUpperCase();
    if (blockedMag(u)) return false;
    return true;
  }

  function preferHits(hits, pred, strict) {
    var good = [];
    var rest = [];
    (hits || []).forEach(function (h) {
      if (!usableHit(h)) return;
      if (pred && pred(h)) good.push(h);
      else rest.push(h);
    });
    var out = (strict ? good : (good.length ? good : rest)).slice(0, 8);
    var seen = {};
    return out.filter(function (h) {
      if (seen[h.handle]) return false;
      seen[h.handle] = 1;
      return true;
    });
  }

  function forgetPred(row) {
    return function (hit) {
      if (!C) return true;
      if (row.id === 'knives') return !!(C.knifeClassify && C.knifeClassify(hit.title, hit.vendor));
      if (C.gearClassify) {
        var g = C.gearClassify(hit.title, hit.vendor);
        if (row.id === 'optics') return !!(g && g.cat === 'optics');
        if (g && g.cat === row.id) return true;
        if (row.id === 'storage' && g && g.cat === 'storage') return true;
      }
      return false;
    };
  }

  function typePred(row) {
    return function (hit) {
      if (!C || !row.gunId) return true;
      var guns = C.gunFamiliesOf ? (C.gunFamiliesOf(hit.title, hit.vendor, '') || []) : [];
      if (guns.indexOf(row.gunId) === -1) return false;
      if (row.typeId && C.partType) {
        var pt = C.partType(hit.title, hit.vendor, '');
        if (row.gunPlat && row.gunPlat.mergeTypes && row.gunPlat.mergeTypes[pt]) {
          pt = row.gunPlat.mergeTypes[pt];
        }
        if (pt !== row.typeId) return false;
      }
      if (row.model === '556' && row.gunPlat && row.gunPlat.parse === 'ar15' && C.modelsOf) {
        var arMods = C.modelsOf(hit.title, row.gunPlat, '', hit.vendor) || [];
        if ((arMods.indexOf('9mm') !== -1 || arMods.indexOf('300BLK') !== -1) &&
            arMods.indexOf('556') === -1) return false;
        return true;
      }
      if (row.model && !AR15_GAS_SIZE[row.model] && C.modelsOf && row.gunPlat) {
        var mods = C.modelsOf(hit.title, row.gunPlat, '', hit.vendor) || [];
        if (mods.length) {
          if (mods.indexOf(row.model) !== -1) return true;
          if (row.model === '700' && (mods.indexOf('700SA') !== -1 || mods.indexOf('700LA') !== -1)) return true;
          return false;
        }
      }
      return true;
    };
  }

  function applyHit(card, hit) {
    if (!card || !hit) return;
    var link = card.querySelector('[data-related-photo]');
    var imgBox = card.querySelector('.gpc-related-img');
    var img = imgBox && imgBox.querySelector('img');
    var titleEl = card.querySelector('.gpc-related-title');
    var priceEl = card.querySelector('.gpc-related-price');
    if (link && hit.handle) link.setAttribute('href', '/products/' + hit.handle);
    if (titleEl) titleEl.textContent = hit.title || '';
    if (priceEl) priceEl.textContent = hitPrice(hit);
    var src = imgUrl(hit.image);
    if (!src || !imgBox) return;
    if (!img) {
      img = document.createElement('img');
      img.loading = 'lazy';
      img.decoding = 'async';
      imgBox.appendChild(img);
    }
    img.alt = hit.title || '';
    if (img.getAttribute('src') === src) return;
    var pre = new Image();
    pre.onload = function () { img.src = src; };
    pre.onerror = function () { img.src = src; };
    pre.src = src;
  }

  function startRotate(grid) {
    if (!grid) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    grid.querySelectorAll('.gpc-type-preview[data-preview-key]').forEach(function (card, i) {
      var key = card.getAttribute('data-preview-key');
      var pool = previewPools[key];
      if (!pool || pool.length < 2) return;
      card.addEventListener('mouseenter', function () { card.setAttribute('data-paused', '1'); });
      card.addEventListener('mouseleave', function () { card.removeAttribute('data-paused'); });
      if (typeof IntersectionObserver === 'function') {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0] && entries[0].isIntersecting) card.setAttribute('data-on-screen', '1');
          else card.removeAttribute('data-on-screen');
        }, { rootMargin: '80px', threshold: 0.02 });
        io.observe(card);
      } else {
        card.setAttribute('data-on-screen', '1');
      }
      card.setAttribute('data-on-screen', '1');
      previewTimers.push(setInterval(function () {
        if (document.hidden) return;
        if (card.getAttribute('data-paused') === '1') return;
        var n = ((previewIndex[key] || 0) + 1) % pool.length;
        previewIndex[key] = n;
        applyHit(card, pool[n]);
      }, 4200 + (i % 6) * 350));
    });
  }

  function expandPool(list) {
    var out = [];
    (list || []).forEach(function (row) {
      if (!row) return;
      out.push({
        handle: row.h || row.handle,
        title: row.t || row.title || '',
        image: row.i || row.image || '',
        price: row.p != null ? row.p : row.price,
        vendor: row.v || row.vendor || '',
        inventory_available: true
      });
    });
    return out;
  }

  function rawPool(row, modelKey) {
    var data = relatedPools;
    if (!data) return [];
    if (!row.gunId) return (data.forget && data.forget[row.id]) || [];
    var gun = data.guns && data.guns[row.gunId];
    var types = gun && row.typeId && gun[row.typeId];
    if (!types) return [];
    if (modelKey && types[modelKey] && types[modelKey].length) return types[modelKey];
    return types.all || [];
  }

  function fillRow(row, pred) {
    var strict = !!row.typeId;
    var picked = preferHits(expandPool(rawPool(row, row.model)), pred, strict);
    if (picked.length < 2 && row.gunId && row.model) {
      var wide = preferHits(expandPool(rawPool(row, '')), pred, strict);
      if (wide.length > picked.length) picked = wide;
    }
    return Promise.resolve(picked);
  }

  function paintGrid(grid, rows, predFor) {
    if (!grid || !rows.length) return Promise.resolve();
    grid.innerHTML = rows.map(function (row) {
      return picCard(row, null);
    }).join('');
    return Promise.all(rows.map(function (row) {
      return fillRow(row, predFor(row)).then(function (pool) {
        previewPools[row.key] = pool;
        previewIndex[row.key] = 0;
        var card = grid.querySelector('[data-preview-key="' + row.key + '"]');
        if (card && pool[0]) applyHit(card, pool[0]);
      });
    })).then(function () { startRotate(grid); });
  }

  function buildForgetRows() {
    var skip = currentBucket();
    var seen = {};
    var rows = [];
    function take(row) {
      if (!row || seen[row.id] || rows.length >= 8) return;
      if (row.id === skip) return;
      seen[row.id] = 1;
      rows.push({
        id: row.id,
        key: 'forget:' + row.id,
        label: row.label,
        href: row.href,
        q: row.q
      });
    }
    FORGET.forEach(take);
    FORGET_EXTRA.forEach(take);
    return rows;
  }

  function buildTypeRows(data) {
    var gun = pickGun();
    var bucket = currentBucket();
    var rows = [];
    if (gun) {
      var models = C.modelsOf ? (C.modelsOf(title, gun.plat, desc, vendor) || []) : [];
      var model = pickModel(gun.plat, models);
      var platIndex = data && data.platforms && data.platforms[gun.id];
      var typeRows = [];
      var ar15Standard = gun.plat.parse === 'ar15' && (!model || model === '556' || AR15_GAS_SIZE[model]);
      if (ar15Standard && platIndex && platIndex.types) {
        typeRows = platIndex.types;
      } else if (model && platIndex && platIndex.typesByModel && platIndex.typesByModel[model]) {
        typeRows = platIndex.typesByModel[model];
      } else if (platIndex && platIndex.types) {
        typeRows = platIndex.types;
      }
      var hide = (model && gun.plat.hideTypesByModel && gun.plat.hideTypesByModel[model]) || {};
      var i;
      for (i = 0; i < typeRows.length && rows.length < 12; i++) {
        var tid = typeRows[i].id;
        if (!tid || tid === bucket || hide[tid]) continue;
        if (gun.plat.hideTypes && gun.plat.hideTypes[tid]) continue;
        rows.push({
          id: tid,
          key: 'types:' + tid,
          typeId: tid,
          gunId: gun.id,
          gunPlat: gun.plat,
          model: model,
          label: typeRows[i].label || typeLabel(tid),
          href: typeHref(gun.id, model, tid, gun.plat),
          q: gunTypeQuery(gun, model, tid)
        });
      }
      var gunName = (C.gunFamilyLabel && C.gunFamilyLabel(gun.id)) || gun.plat.name || gun.id;
      var modelName = modelLabel(gun.plat, model);
      var who = gunName;
      if (modelName && !ar15Standard) who = gunName + ' ' + modelName;
      if (typesTitle) typesTitle.textContent = 'More for ' + who;
      if (typesBlurb) {
        typesBlurb.textContent = 'Other ' + who + ' parts. Tap a photo to open that item, or see more of the type.';
      }
    }
    if (rows.length < 4) {
      if (typesTitle && !gun) typesTitle.textContent = 'Shop by part';
      if (typesBlurb && !gun) {
        typesBlurb.textContent = 'Tap a photo to open that item, or see more of the type.';
      }
      GENERIC_TYPES.forEach(function (row) {
        if (rows.length >= 12) return;
        if (row.id === bucket) return;
        var exists = rows.some(function (r) { return r.id === row.id; });
        if (exists) return;
        rows.push({
          id: row.id,
          key: 'types:' + row.id,
          label: row.label,
          href: row.href,
          q: row.q
        });
      });
    }
    return rows;
  }

  function finish() {
    if (homeBtn) homeBtn.classList.remove('hidden');
    root.hidden = false;
  }

  function run(data) {
    var forgetRows = buildForgetRows();
    var typeRows = buildTypeRows(data);
    if (forgetRows.length && forgetEl && forgetGrid) {
      forgetEl.classList.remove('hidden');
    }
    if (typeRows.length && typesEl && typesGrid) {
      typesEl.classList.remove('hidden');
    }
    finish();
    return Promise.all([
      paintGrid(forgetGrid, forgetRows, forgetPred),
      paintGrid(typesGrid, typeRows, function (row) {
        return row.gunId ? typePred(row) : forgetPred(row);
      })
    ]);
  }

  function loadJson(url) {
    if (!url) return Promise.resolve(null);
    return fetch(url, { credentials: 'omit' }).then(function (r) {
      return r.ok ? r.json() : null;
    }).catch(function () { return null; });
  }

  var indexUrl = (window.GPC && window.GPC.browseIndexUrl) || '';
  var poolsUrl = (window.GPC && window.GPC.relatedPoolsUrl) || '';
  Promise.all([loadJson(indexUrl), loadJson(poolsUrl)]).then(function (pair) {
    relatedPools = pair[1];
    return run(pair[0]);
  }).catch(function () { run(null); });
})();
